import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cat-grid-switch"
export default class extends Controller {

  static targets = ["switch"]

  connect() {
  }

  toggle(event) {
    const isGrid = event.currentTarget.classList.contains('gridview')
    this.element.classList.toggle('gridview', isGrid)
    this.switchTargets.forEach(switchEl => {
      switchEl.querySelector('.gridview').classList.toggle('active', isGrid)
      switchEl.querySelector('.rowview').classList.toggle('active', !isGrid)
    })
  }
}
